export default {
    pmusers_delete_users: "Delete Users",
    pmusers_do_you_want_to_delete: "Do you want to delete users?",
    pmusers_users_have_been_removed: "Users have been removed",
}